import { render, staticRenderFns } from "./result3.vue?vue&type=template&id=35d9b4c2&scoped=true&"
import script from "./result3.vue?vue&type=script&lang=js&"
export * from "./result3.vue?vue&type=script&lang=js&"
import style0 from "./result3.vue?vue&type=style&index=0&id=35d9b4c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d9b4c2",
  null
  
)

export default component.exports